module.exports = __webpack_public_path__ + "img/model_36.37c0c0d7.jpg";